module.exports = __webpack_public_path__ + "images/confounded-normal.png";